import { render, staticRenderFns } from "./tabSettings.vue?vue&type=template&id=4e2d96a2&scoped=true"
import script from "./tabSettings.vue?vue&type=script&lang=js"
export * from "./tabSettings.vue?vue&type=script&lang=js"
import style0 from "./tabSettings.vue?vue&type=style&index=0&id=4e2d96a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d96a2",
  null
  
)

export default component.exports